import type { ReactNode } from "react";

type Props = {
  label: string;
  open: boolean;
  onToggle: () => void;
  /** Optional content (e.g. a tab bar) shown in the header row when open. */
  headerExtra?: ReactNode;
  children: ReactNode;
};

export function EditorCollapsibleBottomPanel({
  label,
  open,
  onToggle,
  headerExtra,
  children,
}: Props) {
  return (
    <section
      className={`editor-bottom-panel${open ? "" : " editor-bottom-panel--collapsed"}`}
      aria-label={label}
    >
      <div className="editor-bottom-panel-chrome">
        <button
          type="button"
          className="editor-bottom-panel-toggle surf-btn surf-btn--ghost"
          onClick={onToggle}
          aria-expanded={open}
          aria-label={open ? `Riduci ${label}` : `Espandi ${label}`}
          title={open ? `Riduci ${label}` : `Espandi ${label}`}
        >
          {open ? "▾" : "▴"}
        </button>
        {open ? (
          headerExtra ?? <span className="editor-bottom-panel-title">{label}</span>
        ) : (
          <button
            type="button"
            className="editor-bottom-panel-rail"
            onClick={onToggle}
            aria-label={`Espandi ${label}`}
            title={`Espandi ${label}`}
          >
            {label}
          </button>
        )}
      </div>
      {open && <div className="editor-bottom-panel-body">{children}</div>}
    </section>
  );
}
